export default __webpack_public_path__ + "static/media/Bobi.21a298b7.png";